import { useEffect } from 'react'

export function BackgroundPreloader() {
  useEffect(() => {
    // List of all background images used in the slideshow - 2025-01-XX
    const backgroundImages = [
      '/media/backgrounds/star-wars-galaxies-sci-fi-mmo.avif',
      '/media/backgrounds/screenShot0002.jpg',
      '/media/backgrounds/screenShot0003.jpg',
      '/media/backgrounds/screenShot0004.jpg',
      '/media/backgrounds/screenShot0005.jpg',
      '/media/backgrounds/screenShot0006.jpg',
      '/media/backgrounds/screenShot0007.jpg',
      '/media/backgrounds/screenShot0008.jpg',
      '/media/backgrounds/screenShot0009.jpg',
      '/media/backgrounds/screenShot0010.jpg',
      '/media/backgrounds/screenShot0011.jpg',
      '/media/backgrounds/screenShot0012.jpg',
      '/media/backgrounds/screenShot0013.jpg'
    ]

    // Preload all background images
    backgroundImages.forEach((imageSrc) => {
      const img = new Image()
      img.src = imageSrc
      // Add error handling
      img.onerror = () => {
        console.warn(`Failed to preload background image: ${imageSrc}`)
      }
    })

    // Preload background videos to prevent flash - 2025-01-XX
    const backgroundVideos = [
      '/media/backgrounds/space-animation.webm',
      '/media/backgrounds/space-stars-animation.webm'
    ]

    backgroundVideos.forEach((videoSrc) => {
      const video = document.createElement('video')
      video.src = videoSrc
      video.preload = 'auto'
      video.muted = true
      video.style.display = 'none'
      video.onerror = () => {
        console.warn(`Failed to preload background video: ${videoSrc}`)
      }
      document.body.appendChild(video)
      // Remove after a short delay to free DOM but keep cached
      setTimeout(() => {
        if (document.body.contains(video)) {
          document.body.removeChild(video)
        }
      }, 1000)
    })

    // Preload space.jpg specifically for credits page - 2025-01-XX
    const spaceImg = new Image()
    spaceImg.src = '/media/backgrounds/space.jpg'
  }, [])

  return null // This component doesn't render anything
}
